import { Ajax } from './axios';
// 资讯
export default {
  // 添加文章浏览记录
  articleLookRecordAddPOST(param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/articleLookRecord/add', { ...param });
  },
  articlePageForH5POST(param = {}) {
    return Ajax.post('/api/gugongExaminee/v1/common/news/page', { ...param });
  },
  getNewsDetailGET(param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/common/news/getNewsDetail`, { ...param });
  },
};
